import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(private readonly authService: AuthService, private readonly router: Router) {}

async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    
      // Ensure user is loaded from storage before checking
    await this.authService.loadUserFromStorage();

    const currentUser = this.authService.getCurrentUser();
    
    if (currentUser) {
      // User is already logged in, redirect to appropriate dashboard based on role
      
      switch (currentUser.role) {
        case 'admin':
          return this.router.createUrlTree(['/user/dashboard']);
        case 'ngo':
          if (currentUser.onboarding_completed) {
            return this.router.createUrlTree(['/ngo/dashboard']);
          } else {
            return this.router.createUrlTree(['/ngo/onboarding']);
          }
        case 'corporate':
          if (currentUser.onboarding_completed) {
            return this.router.createUrlTree(['/corporate/dashboard']);
          } else {
            return this.router.createUrlTree(['/corporate/onboarding']);
          }
        case 'volunteer':
          return this.router.createUrlTree(['/volunteer/dashboard']);
        default:
          return this.router.createUrlTree(['/']);
      }
    }
    
    // User is not authenticated, allow access to login page
    return true;
  }
}
